export var RESET_SEARCH = 'RESET_SEARCH';
export var SET_DESCRIPTION = 'SET_DESCRIPTION';
export var SET_PRODUCTS = 'SET_PRODUCTS';
export var SET_SUGGESTIONS = 'SET_SUGGESTIONS';
export var APPEND_PRODUCTS = 'APPEND_PRODUCTS';
export var PREPEND_PRODUCTS = 'PREPEND_PRODUCTS';
export var SET_PROVIDER = 'SET_PROVIDER';